import { Component, Inject, OnInit, Optional, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationModalConfig } from '../../../shared/components/confirmation-modal/confirmation-modal.component';

@Component({
    selector: 'gtw-client-load-failed',
    templateUrl: './client-load-failed.component.html',
    styleUrls: ['./client-load-failed.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ClientLoadFailedComponent implements OnInit {

  modalConfig: ConfirmationModalConfig = {
    title: 'Failed to Switch',
    message: 'Unable to change the client! Please Check Assigned: Workspaces OR Scenarios OR Modules etc.',
    iconClass: 'fa fa-sign-out',
    iconColor: 'txt-color-orange-dark',
    confirmButtonText: 'Ok',
    confirmButtonClass: 'btn-success',
    showCancelButton: false,
    showConfirmButton: true,
    animationClass: 'animated fadeIn fast',
    loading: false
  };

  constructor(
    @Optional() private dialogRef?: MatDialogRef<ClientLoadFailedComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data?: { clientName?: string }
  ) {}

  ngOnInit(): void {
    this.updateModalConfig();
  }

  private updateModalConfig(): void {
    const clientName = this.data?.clientName || '';
    this.modalConfig = {
      ...this.modalConfig,
      title: `Failed to Switch ${clientName}`,
      message: `Unable to change the client: ${clientName}! Please Check Assigned: Workspaces OR Scenarios OR Modules etc.`
    };
  }

  onConfirm(): void {
    this.dialogRef?.close();
  }

  cancel(): void {
    this.dialogRef?.close();
  }
}
